import { lazy, Suspense } from 'react';
import { AdminLayout } from 'components/themes/admin';

const OfferingLetterForms = lazy(() => import('modules/admin/master/OfferingLetterForms'));

const OfferingLetterFormsPage = (props) => (
  <AdminLayout>
    <Suspense fallback={null}>
      <OfferingLetterForms />
    </Suspense>
  </AdminLayout>
);

export default OfferingLetterFormsPage;